import { render, staticRenderFns } from "./SessionListHistoryTable.vue?vue&type=template&id=241f4df9&scoped=true"
import script from "./SessionListHistoryTable.vue?vue&type=script&lang=ts"
export * from "./SessionListHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./SessionListHistoryTable.vue?vue&type=style&index=0&id=241f4df9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f4df9",
  null
  
)

export default component.exports